jQuery(document).ready(function ($) {
    $('a.c-btn[data-action="show-more"]').click(function (e) {
        e.preventDefault();

        var $this = $(this),
            $parent = $this.parent(),
            $columns = $parent.find('ul.column');

        $columns.addClass('visible');
        $this.hide();
    })
});